import PropTypes from 'prop-types';

import { noop } from '../../../helpers/noop';
import Loading from '../../Loading/Loading.component';

import styleSheet from './scss/submitButton.module.scss';

const styles = styleSheet.locals || {};

/**
 * Component which allows fan to vote for an option
 *
 * @param {object} props poll option props
 * @param {Function} props.onSubmit on submit callback
 * @param {boolean} props.disabled if button is disabled
 * @param {string} props.title button title attribute text
 * @param {string} props.buttonText button text
 * @param {boolean} props.loading if button should show loading state
 * @param props.buttonPart
 * @param {string} [props.dataCy] test hook selector, defaults to "submitButton"
 * @returns {Function} <SubmitButton />
 */
function SubmitButton({
    onSubmit = noop,
    disabled = false,
    title = '',
    buttonText = '',
    loading = false,
    buttonPart = 'submit-button',
    loadingPart = 'submit-button-loading',
    dataCy = 'submitButton'
}) {
    return (
        <>
            <style>{styleSheet.toString()}</style>
            <button
                data-cy={dataCy}
                className={styles.submitButton}
                part={buttonPart}
                onClick={onSubmit}
                disabled={disabled}
                title={title}
                id={'submit-button'}
            >
                {loading ? (
                    <Loading size={14} part={loadingPart} />
                ) : (
                    buttonText
                )}
            </button>
        </>
    );
}

SubmitButton.propTypes = {
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    loading: PropTypes.bool,
    buttonPart: PropTypes.string,
    loadingPart: PropTypes.string,
    dataCy: PropTypes.string
};

export default SubmitButton;
